import React from "react"
import styled from "@emotion/styled"
import { css } from "@emotion/core"

const Note = styled.span`
  font-size: 12px;
  text-transform: uppercase;
  display: block;
  margin: 20px;
  margin-bottom: 0px;
  margin-top: 40px;
`

const Sample = ({ children, fontSize, fontWeight, lineHeight}) => (
    <div>
        <Note>{fontSize} - {fontWeight} - {lineHeight ? lineHeight : 1.2}</Note>
        <div
            contenteditable="true"
            spellcheck="false"
            css={css`
                padding: 20px;
                line-height: ${lineHeight ? lineHeight : 1.2};
                font-size: ${fontSize};
                font-weight: ${fontWeight};
                &:hover {
                    background-color: rgba(255,176,0,0.1);
                  }
                `
            }
        >
            {children}
        </div>
    </div>
)

export default Sample